var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoadSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 14.6673C11.6821 14.6673 14.6668 11.6825 14.6668 8.00065C14.6668 4.31875 11.6821 1.33398 8.00016 1.33398C4.31826 1.33398 1.3335 4.31875 1.3335 8.00065C1.3335 11.6825 4.31826 14.6673 8.00016 14.6673ZM8.00016 13.334C9.23264 13.334 10.3675 12.9159 11.2706 12.2139L8.00016 8.94346L4.72973 12.2139C5.63286 12.9159 6.76769 13.334 8.00016 13.334ZM3.78692 11.2711L7.05735 8.00065L3.78692 4.73022C3.08488 5.63334 2.66683 6.76818 2.66683 8.00065C2.66683 9.23313 3.08488 10.368 3.78692 11.2711ZM8.00016 7.05784L4.72973 3.78741C5.63286 3.08537 6.76769 2.66732 8.00016 2.66732C9.23264 2.66732 10.3675 3.08537 11.2706 3.78741L8.00016 7.05784ZM8.94297 8.00065L12.2134 4.73022C12.9154 5.63334 13.3335 6.76818 13.3335 8.00065C13.3335 9.23313 12.9154 10.368 12.2134 11.2711L8.94297 8.00065Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadSign);
export default __webpack_public_path__ + "static/media/road-sign.c08a50e0437460209cfa40d69053ff5f.svg";
export { ForwardRef as ReactComponent };